<section class="invoice-row-form astral-sidebar-shell">
  @if (form) {
    <form [formGroup]="form" class="invoice-row-form__form" id="lease-row-form" novalidate>
      <div class="invoice-row-form__content astral-sidebar-content astral-stack-l">
        <h2 class="astral-sidebar-heading">{{ header | translate }}</h2>
        <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
          @if (showArticleSelect) {
            <div class="astral-layout-item">
              <app-autocomplete-remote
                [control]="form.controls['articleId']"
                [defaultSearch]="'*'"
                [service]="articleService"
              ></app-autocomplete-remote>
            </div>
          }
          <astral-input [control]="form.controls['description']"></astral-input>
          @if (!isInformation) {
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
              <app-money-box [control]="form.controls['amount']"></app-money-box>
              <app-money-box [control]="form.controls['amountIncludingVat']"></app-money-box>
            </astral-layout-group>
          }
        </section>
        @if (displayCoding) {
          <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
            <h3 class="astral-section-heading">{{ 'INVOICE_ROW.CODING' | translate }}</h3>
            @if (dataContext.isNew && dataContext.codingDefaultValues.basedOnLeaseAgreement) {
              <div>
                <app-information-block
            [text]="
              'INVOICE_ROW.INFORMATION_TEXT.DEFAULT_CODING_FROM_LEASE_AGREEMENT'
                | translate : { leaseAgreementNumber: dataContext.codingDefaultValues.basedOnLeaseAgreement.leaseAgreementNumber }
            "
                  >
                </app-information-block>
              </div>
            }
            <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
              @if (codingConfig.useCostPlace) {
                <astral-select [control]="codingForm.controls['costPlace']" [itemsSource]="costPlaces"></astral-select>
              }
              @if (codingConfig.useCostBearer) {
                <astral-select [control]="codingForm.controls['costBearer']" [itemsSource]="costBearers"></astral-select>
              }
              @if (codingConfig.useCounterpart) {
                <astral-select [control]="codingForm.controls['counterpart']" [itemsSource]="counterparts"></astral-select>
              }
              @if (codingConfig.useProject) {
                <astral-input [control]="codingForm.controls['project']"></astral-input>
              }
              @if (codingConfig.useFunction) {
                <astral-input [control]="codingForm.controls['function']"></astral-input>
              }
            </astral-layout-group>
          </section>
        }
      </div>
      <div class="invoice-row-form__footer astral-sidebar-footer">
        @if (!dataContext.isReadonly) {
          <astral-button variant="primary" type="submit" labelKey="OK_BTN" (click)="submit()"></astral-button>
        }
        @if (!dataContext.isReadonly) {
          <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
        }
        @if (dataContext.isReadonly) {
          <astral-button variant="primary" type="button" labelKey="OK_BTN" (click)="cancel()"></astral-button>
        }
        @if (allowDelete) {
          <astral-button variant="secondary" type="button" icon="trash" labelKey="DELETE_BTN" (click)="delete()"></astral-button>
        }
      </div>
    </form>
  }
</section>
